import Landing from './Landing';

export default function App() {
  return <Landing />;
}
